import api from './api';

export const eventsAPI = {
  // ─── CMS ────────────────────────────────────────────────────────────────

  getAll: (params?: {
    status?: string;
    category?: string;
    from_date?: string;
    to_date?: string;
    search?: string;
    page?: number;
    limit?: number;
  }) => api.get('/events', { params }),

  getById: (id: string) => api.get(`/events/${id}`),

  create: (data: Record<string, any>) => api.post('/events', data),

  update: (id: string, data: Record<string, any>) => api.put(`/events/${id}`, data),

  delete: (id: string) => api.delete(`/events/${id}`),

  // Documents / images
  uploadDocuments: (id: string, files: File[], fileType: 'image' | 'document' | 'poster' = 'document') => {
    const formData = new FormData();
    files.forEach(f => formData.append('files', f));
    return api.post(`/events/${id}/documents?file_type=${fileType}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  uploadImage: (id: string, file: File, field: 'featured_image' | 'poster_image') => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/events/${id}/images?field=${field}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  deleteDocument: (eventId: string, docId: string) =>
    api.delete(`/events/${eventId}/documents/${docId}`),

  // ─── Registrations ───────────────────────────────────────────────────────

  getRegistrations: (
    eventId: string,
    params?: {
      registration_status?: string;
      attendance_status?: string;
      verification_status?: string;
      search?: string;
      page?: number;
      limit?: number;
    }
  ) => api.get(`/events/${eventId}/registrations`, { params }),

  getRegistrationById: (eventId: string, regId: string) =>
    api.get(`/events/${eventId}/registrations/${regId}`),

  updateRegistrationStatus: (
    eventId: string,
    regId: string,
    data: { registration_status: string; review_notes?: string }
  ) => api.patch(`/events/${eventId}/registrations/${regId}/status`, data),

  bulkUpdateStatus: (
    eventId: string,
    data: { registration_ids: string[]; registration_status: string; review_notes?: string }
  ) => api.patch(`/events/${eventId}/registrations/bulk-status`, data),

  updateAttendance: (
    eventId: string,
    regId: string,
    attendance_status: string
  ) => api.patch(`/events/${eventId}/registrations/${regId}/attendance`, { attendance_status }),

  verifyPayment: (
    eventId: string,
    regId: string,
    data: { payment_verified: boolean; payment_notes?: string }
  ) => api.patch(`/events/${eventId}/registrations/${regId}/verify-payment`, data),

  verifyIdentity: (
    eventId: string,
    regId: string,
    data: { verification_status: string; verification_notes?: string }
  ) => api.patch(`/events/${eventId}/registrations/${regId}/verify-identity`, data),

  exportRegistrations: (eventId: string, status?: string) => {
    const params = status ? `?registration_status=${status}` : '';
    return api.get(`/events/${eventId}/registrations/export${params}`, {
      responseType: 'blob',
    });
  },
};